<template>
  <component
    :is="filterName"
    :options-endpoint-url="filterOptionsUrl"
    @update:model-value="filterResults"
  />
</template>

<script>
import { defineComponent } from "vue";
import IncludesRequiredChecksOptions from "../filter-bar-options/includes-required-checks-options.vue";
import StaffTableOptions from "../filter-bar-options/staff-table-options.vue";
export default defineComponent({
  name: "FilterBar",
  components:{
    IncludesRequiredChecksOptions,
    StaffTableOptions
  },
  props:{
    filterName:{
      type: String,
      default: ""
    },
    filterOptionsUrl:{
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(_, { emit }) {
   
    const filterResults = (val)=>{
      emit("update:modelValue", val);
    };

    return {
      filterResults,
    };
  }
});
</script>
